<template>
  <span
    class="user-avatar"
    :class="`user-avatar--${size}`"
    :aria-label="ariaLabel"
    role="img"
  >
    <img v-if="avatarSrc" :src="avatarSrc" alt="" class="user-avatar-image" />
    <span v-else class="user-avatar-fallback">{{ initials }}</span>
  </span>
</template>

<script setup>
import { computed } from 'vue'
import { userDisplayName } from '../utils/userDisplay'

const props = defineProps({
  user: {
    type: Object,
    default: null,
  },
  size: {
    type: String,
    default: 'md',
    validator: (value) => ['sm', 'md', 'lg'].includes(value),
  },
})

const avatarSrc = computed(() => props.user?.avatar_thumb_url || props.user?.avatar_url)

const initials = computed(() => {
  const source =
    props.user?.name?.trim() ||
    props.user?.username?.trim() ||
    props.user?.display_name?.replace(/^@/, '').trim() ||
    ''
  if (source) {
    return source.charAt(0).toUpperCase()
  }
  return props.user?.id ? String(props.user.id).charAt(0) : '?'
})

const ariaLabel = computed(() => userDisplayName(props.user) || 'Пользователь')
</script>

<style scoped>
.user-avatar {
  position: relative;
  display: inline-block;
  flex-shrink: 0;
  border-radius: 999px;
  overflow: hidden;
  background: #e2e8f0;
  color: #475569;
  font-weight: 600;
  line-height: 1;
  vertical-align: middle;
}

.user-avatar--sm {
  width: 24px;
  height: 24px;
  font-size: 0.6875rem;
}

.user-avatar--md {
  width: 32px;
  height: 32px;
  font-size: 0.8125rem;
}

.user-avatar--lg {
  width: 64px;
  height: 64px;
  font-size: 1.25rem;
}

.user-avatar-image {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.user-avatar-fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
</style>
